export const INVOICE_FILE_TYPES = ['invoice', 'invoice-receipt', 'invoice-credit'];

export const EMAIL_DATE_LOCALES = {
  en: 'en-US',
  heb: 'he-IL',
};

export const DEFAULT_EMAIL_DATE_LOCALE = 'he-IL';

export const EMPTY_VALUE_PLACEHOLDER = '-';

export const COLUMN_NAMES = {
  emailDate: 'emailDate',
  senderAddress: 'senderAddress',
  fileNumber: 'fileNumber',
  fileType: 'fileType',
  userNo: 'userSantecAccountId',
  clientNo: 'clientSantecAccountId',
  userEmail: 'userEmail',
  clientEmail: 'clientEmail',
  sentToUser: 'sentToUser',
  reasonWhyNotSentToUser: 'reasonWhyNotSentToUser',
  sentToClient: 'sentToClient',
  reasonWhyNotSentToClient: 'reasonWhyNotSentToClient',
};

export const REASON_COLUMN_NAMES = [
  COLUMN_NAMES.reasonWhyNotSentToUser,
  COLUMN_NAMES.reasonWhyNotSentToClient,
];

export const FIELD_LABEL_KEYS = {
  [COLUMN_NAMES.emailDate]: 'email-tracking-col-email-date',
  [COLUMN_NAMES.senderAddress]: 'email-tracking-col-sender-address',
  [COLUMN_NAMES.fileNumber]: 'email-tracking-col-file-number',
  [COLUMN_NAMES.fileType]: 'email-tracking-col-file-type',
  [COLUMN_NAMES.userNo]: 'email-tracking-col-user-no',
  [COLUMN_NAMES.clientNo]: 'email-tracking-col-client-no',
  [COLUMN_NAMES.userEmail]: 'email-tracking-col-user-email',
  [COLUMN_NAMES.clientEmail]: 'email-tracking-col-client-email',
  [COLUMN_NAMES.sentToUser]: 'email-tracking-col-sent-to-user',
  [COLUMN_NAMES.reasonWhyNotSentToUser]: 'email-tracking-col-reason-not-sent-to-user',
  [COLUMN_NAMES.sentToClient]: 'email-tracking-col-sent-to-client',
  [COLUMN_NAMES.reasonWhyNotSentToClient]: 'email-tracking-col-reason-not-sent-to-client',
};

export const SERVER_ERROR_MESSAGE_KEYS = {
  'from and to query params are required': 'email-tracking-select-from-to-dates',
  'to must be greater than or equal to from': 'email-tracking-invalid-range',
  'date range cannot exceed 7 days': 'email-tracking-max-range-week',
};

export const REASON_CODE_KEYS = {
  unsupported_file_type: {
    default: 'email-tracking-reason-unknown-type',
  },
  file_number_missing: {
    default: 'email-tracking-reason-unknown-number',
  },
  document_not_found_in_db: {
    invoice: 'email-tracking-reason-invoice-not-found',
    receipt: 'email-tracking-reason-receipt-not-found',
  },
  user_missing: {
    invoice: 'email-tracking-reason-user-not-found-invoice',
    receipt: 'email-tracking-reason-user-not-found-receipt',
  },
  client_missing: {
    invoice: 'email-tracking-reason-client-not-found-invoice',
    receipt: 'email-tracking-reason-client-not-found-receipt',
  },
  user_email_missing: {
    default: 'email-tracking-reason-user-email-missing',
  },
  client_email_missing: {
    default: 'email-tracking-reason-client-email-missing',
  },
  unauthorized_sender: {
    default: 'email-tracking-reason-unauthorized-sender',
  },
  no_attachments: {
    default: 'email-tracking-reason-no-attachments',
  },
  company_id_not_allowed: {
    default: 'email-tracking-reason-company-id-not-allowed',
  },
  email_mismatch_between_databases: {
    default: 'email-tracking-reason-email-mismatch',
  },
  storage_upload_failed: {
    default: 'email-tracking-reason-storage-upload-failed',
  },
  document_update_failed: {
    default: 'email-tracking-reason-document-update-failed',
  },
  email_send_failed: {
    default: 'email-tracking-reason-email-send-failed',
  },
  email_already_sent: {
    default: 'email-tracking-reason-email-already-sent',
  },
  internal_server_error: {
    default: 'email-tracking-reason-internal-server-error',
  },
};

export const TRANSLATION_KEYS = {
  somethingWentWrong: 'email-tracking-something-went-wrong',
  selectFromToDates: 'email-tracking-select-from-to-dates',
  invalidRange: 'email-tracking-invalid-range',
  reportTitle: 'email-tracking-report-title',
  rangeLabel: 'email-tracking-range-label',
  loadReport: 'email-tracking-load-report',
  noEmailsFound: 'email-tracking-no-emails-found',
  noDataForEmail: 'email-tracking-no-data-for-email',
  emailTitle: 'email-tracking-email-title',
  from: 'from',
  to: 'to',
  true: 'true',
  false: 'false',
  filterUnsent: 'email-tracking-filter-unsent',
};
